import { Transition } from '@uirouter/core';
import { Action } from '../../common/actions/core/action';
import { PaymentMethod } from '../services/payment-method.model';

export class CardDeleteAction implements Action {
  constructor(
    public onDeleteSuccess: (paymentMethodID: number, cardId: string) => any,
    public card: PaymentMethod
  ) {}
}



// WEBPACK FOOTER //
// src/app/buy/card-delete-dialog/card-delete-dialog.action.ts